module.exports = __webpack_public_path__ + "static/media/loopback.b25e9c3d.svg";